import React from 'react';
import './Header.css';

class Header extends React.Component {
  render() {
    return (
      <div style={{ marginBottom: '64px' }}>
        <header id="HEADER_1">
          <div id="DIV_2">
            <a href="https://www.13cabs.com.au/" id="A_3">
              <img
                src="https://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/Branding/13cabs/logo.svg"
                alt="logo"
                id="IMG_4"
              />
            </a>
            <div id="DIV_9">
              <div id="DIV_10">
                <a href="https://www.13cabs.com.au" id="A_11">
                  <span id="SPAN_12">Home</span>
                </a>
                <a href="https://book.13cabs.com.au/booking" id="A_13">
                  <span id="SPAN_14">Book a taxi</span>
                </a>
                <a href="https://book.13cabs.com.au/contact-us" id="A_15">
                  <span id="SPAN_16">Contact us</span>
                </a>
              </div>
              <div id="DIV_17">
                <img
                  src="https://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/Header/menu_rounded_solid.png"
                  width="20"
                  id="IMG_18"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div id="DIV_25">
            <div id="DIV_26">
              <div id="DIV_27">
                <div id="DIV_28">
                  <div id="DIV_29">WHAT'S NEW</div>
                  <img
                    src="https://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/CheckAndX/x-circle-black.png"
                    alt="close"
                    id="IMG_30"
                  />
                </div>
              </div>
              <div id="DIV_31">
                <div id="DIV_32"></div>
                <div id="DIV_33">
                  <span id="SPAN_34">Last viewed</span>
                  <hr id="HR_35" />
                </div>
                <div id="DIV_36">
                  <div id="DIV_37">
                    <div id="DIV_38">
                      <span id="SPAN_39"></span>
                      <span id="SPAN_40">21.09.2020</span>
                    </div>
                    <div id="DIV_41">TRACK MULTIPLE TRIPS</div>
                    <div id="DIV_42">
                      Track multiple bookings at once. See the live status of cabs, in detail on
                      maps.
                    </div>
                    <div id="DIV_43">
                      <img
                        src="https://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/WhatsNew/track-trips.png"
                        alt="Track Trips"
                        id="IMG_44"
                      />
                    </div>
                    <div id="DIV_45">
                      <span id="SPAN_46">Not signed up?</span> No problem.{' '}
                      <a href="https://book.13cabs.com.au/contact-us#" id="A_47">
                        Tap here
                      </a>{' '}
                      to access favourites, payments and more.
                    </div>
                  </div>
                  <div id="DIV_48">
                    <div id="DIV_49">
                      <span id="SPAN_50"></span>
                      <span id="SPAN_51">21.09.2020</span>
                    </div>
                    <div id="DIV_52">DRIVER PROFILE PICTURES</div>
                    <div id="DIV_53">
                      When your cab's on the way, put a face to your Driver's name
                    </div>
                    <div id="DIV_54">
                      <img
                        src="hhttps://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/WhatsNew/Driver-profile.png"
                        alt="Driver Profile"
                        id="IMG_55"
                      />
                    </div>
                    <div id="DIV_56">
                      <span id="SPAN_57">Not signed up?</span> No problem.{' '}
                      <a href="https://book.13cabs.com.au/contact-us#" id="A_58">
                        Tap here
                      </a>{' '}
                      to access favourites, payments and more.
                    </div>
                  </div>
                  <div id="DIV_59">
                    <div id="DIV_60">
                      <span id="SPAN_61"></span>
                      <span id="SPAN_62">04.06.2020</span>
                    </div>
                    <div id="DIV_63">NEED A THING DELIVERED NOW?</div>
                    <div id="DIV_64">
                      From grocery things to pharmacy things and all sorts of other things, we’ll
                      bring!
                    </div>
                    <div id="DIV_65">
                      <img
                        src="https://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/WhatsNew/13things.png"
                        alt="Parcel"
                        id="IMG_66"
                      />
                    </div>
                    <div id="DIV_67">
                      Simply click here{' '}
                      <a href="https://book.13cabs.com.au/contact-us#" id="A_68">
                        Parcel Delivery
                      </a>{' '}
                      or choose from ‘Select your service’ when booking next.
                    </div>
                  </div>
                  <div id="DIV_69">
                    <div id="DIV_70">
                      <span id="SPAN_71"></span>
                      <span id="SPAN_72">04.06.2020</span>
                    </div>
                    <div id="DIV_73">BOOK FROM FAVOURITES</div>
                    <div id="DIV_74">
                      Create favourites, and quick book using your previous trips.{' '}
                      <a href="https://book.13cabs.com.au/contact-us#" id="A_75">
                        Click here
                      </a>{' '}
                      to see.
                    </div>
                    <div id="DIV_76">
                      <img
                        src="https://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/WhatsNew/favourites.png"
                        alt="Favourites"
                        id="IMG_77"
                      />
                    </div>
                    <div id="DIV_78">
                      Not signed up? No problem. Simply click here{' '}
                      <a href="https://book.13cabs.com.au/contact-us#" id="A_79">
                        Sign up
                      </a>{' '}
                      to access favourites and more.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    );
  }
}

export default Header;
